import smoothscroll from 'smoothscroll-polyfill';

export default () => smoothscroll.polyfill()
